import { useEffect, useCallback } from "react";
import { CONSTANTS } from "../data";
import type { Quest, GameState } from "../types";

// Split: quest generation, quest completion

const useQuestGeneration = ({ state, dispatch }) => {
  const generateQuest = useCallback((): Quest | null => {
    const availableQuests = CONSTANTS.QUEST_POOL.filter(
      (quest) => !state.quests.some((activeQuest) => activeQuest.id === quest.id)
    );

    if (availableQuests.length === 0) return null;

    const questTemplate =
      availableQuests[Math.floor(Math.random() * availableQuests.length)];
    return {
      ...questTemplate,
      progress: 0,
    };
  }, [state.quests]);

  useEffect(() => {
    if (state.screen === "game" && state.quests.length < 3) {
      const newQuest = generateQuest();
      if (newQuest) {
        dispatch({ type: "ADD_QUEST", quest: newQuest });
      }
    }
  }, [state.screen, state.quests.length, generateQuest, dispatch]);
};

const useQuestCompletion = ({ state, dispatch }) => {
  const generateQuest = useCallback((): Quest | null => {
    const availableQuests = CONSTANTS.QUEST_POOL.filter(
      (quest) => !state.quests.some((activeQuest) => activeQuest.id === quest.id)
    );

    if (availableQuests.length === 0) return null;

    const questTemplate =
      availableQuests[Math.floor(Math.random() * availableQuests.length)];
    return {
      ...questTemplate,
      progress: 0,
    };
  }, [state.quests]);

  useEffect(() => {
    state.quests.forEach((quest) => {
      if (quest.progress >= quest.target) {
        dispatch({ type: "COMPLETE_QUEST", questId: quest.id });

        if (quest.reward.type === "coins") {
          dispatch({ type: "ADD_COINS", amount: quest.reward.amount });
        } else if (quest.reward.type === "xp") {
          dispatch({ type: "ADD_XP", amount: quest.reward.amount });
        }

        setTimeout(() => {
          const newQuest = generateQuest();
          if (newQuest) {
            dispatch({ type: "ADD_QUEST", quest: newQuest });
          }
        }, 1000);
      }
    });
  }, [state.quests, generateQuest, dispatch]);
};

const useQuestSystem = (props: { state: GameState; dispatch: any }) => {
  useQuestGeneration(props);
  useQuestCompletion(props);
};

export default useQuestSystem;
